var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('search-box',{staticClass:"w-100",attrs:{"results":_vm.searchedCountries,"placeholder":this.name || 'Search country...'},on:{"typing":_vm.searchCountry,"selected":_vm.selectCountry}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }